import { Component, Input, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Agent, Attachment, User } from '../../shared/models';

@Component({
	selector: 'pk-broker-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: false,
})
export class FooterComponent implements OnInit {
	@Input() user: User;
	@Input() agent: Agent;
	@Input() isDirect: boolean;
	@Input() isBillReader: boolean;
	@Input() useDefault: boolean;
	@Input() isEnergyPortal: boolean;
	@Input() defaultFooterLogoAttachment: Attachment;
	@Input() defaultEnergyPortalLogoAttachment: Attachment;

	public environment = environment;
	public year: number;

	ngOnInit(): void {
		this.year = new Date().getFullYear();
	}

	get hasCustomEnergyPortalLogo(): boolean {
		return this.isEnergyPortal && !!this.defaultEnergyPortalLogoAttachment;
	}

	get activeFooterLogoAttachment(): Attachment {
		if (this.hasCustomEnergyPortalLogo) {
			return this.defaultEnergyPortalLogoAttachment;
		}

		// Enterprise users have no agent, so their branding comes off the enterprise.
		return this.agent?.darkDisplayLogoAttachment ?? this.user?.enterprise?.darkDisplayLogoAttachment ?? this.defaultFooterLogoAttachment;
	}
	get activeFooterLogoHeight(): number {
		return !this.hasCustomEnergyPortalLogo ? 45 : 8;
	}

	get showBranding(): boolean {
		const hasLogo = !!this.activeFooterLogoAttachment;
		return (!this.isDirect && (!!this.user || hasLogo)) || (this.isDirect && (!!this.agent || hasLogo));
	}

	get companyName(): string {
		if (this.user?.enterprise) {
			return this.user.enterprise.name;
		}

		if (!this.user || !this.user.agent) {
			return 'Power Kiosk';
		}

		if (this.user.isSaas) {
			return ''; // for saas hide this for now - if some do want it later, add configuration to show user.company.name
		}

		return this.user.agent.parent ? this.user.agent.parent.customerCompany : this.user.agent.customerCompany;
	}
}
